import Vue from 'vue';
import * as Vuex from 'vuex';
import App from './App.vue';
import router from '@/router';
import { createStore } from '@/store';
import Quasar from 'quasar';
import quasarConfig from '@/quasar.conf';
import './styles/quasar.styl';
import ElementScrollPlugin from '@/plugins/element-scroll';
import * as Directives from '@/directives';

Vue.config.productionTip = false;

Vue.use(Quasar, quasarConfig);
Vue.use(Vuex);
Vue.use(ElementScrollPlugin);

Vue.directive('hack-autocomplete-absolute-position', Directives.HackAutocompleteAbsolutePosition);
Vue.directive('markdown', Directives.RenderMarkdown);
const store = createStore();

new Vue({
	router,
	store,
	render: (h) => h(App),
}).$mount('#app');

router.replace({ name: 'home' });
